"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const layouts_1 = require("../../../shared/layouts");
const avatarUpload_1 = __importDefault(require("./avatarUpload/avatarUpload"));
const profile_1 = require("../../../shared/components/profile");
const contactInfo_1 = __importDefault(require("../components/contactInfo/contactInfo"));
const actionBox_1 = __importDefault(require("../components/actionBox"));
require("./createProfile.scss");
require("../app.scss");
require("../styles/profileInfoContainer.scss");
const react_redux_1 = require("react-redux");
const lawFirmProfileSlice_1 = require("../../../redux/slices/lawFirmProfileSlice");
const svgIcons_1 = require("../../../svgIcons");
const bannerImg = require("../../../assets/images/svg/law-firm-banner.svg");
class CreateProfile extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            openModal: true
        };
        // handle inputs  change event
        this.formChange = (e, field, val = null) => {
            const value = e ? e.target.value : val;
            this.props.userFormChange({ value: value, field: field });
        };
        // handle inputs blur event
        this.validateInput = (e, field) => {
            const value = e.target.value;
            this.props.validateInputs({ value, field });
        };
        // create profile
        this.saveProfile = () => {
            const { formData, successModal } = this.props.lawFirmProfile;
            this.props.validateInputs([
                { value: formData.firm_name, field: 'firm_name' },
                { value: formData.email, field: 'email' },
                { value: formData.contact_person, field: 'contact_person' }
            ]);
            this.props.createProfile();
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { lawFirmProfile: { formUpdated } } = this.props;
        if (formUpdated) {
            localStorage.setItem('profile_changed', 'profile_changed');
        }
        else {
            localStorage.removeItem('profile_changed');
        }
    }
    render() {
        const { openModal } = this.state;
        const { lawFirm, lawFirmProfile } = this.props;
        const { formData, validationFields, apiErrors, formValid, addressValid, avatarLoading, errorMessage, successModal } = lawFirmProfile;
        const user = lawFirm.user;
        return react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("div", { className: "banner-container" },
                react_1.default.createElement("img", { src: bannerImg.default, alt: "img" }),
                react_1.default.createElement("span", { className: "divider" }),
                react_1.default.createElement("div", { className: "text-wrapper" },
                    react_1.default.createElement("p", { className: "title" }, "Get Started Today"),
                    react_1.default.createElement("p", { className: "description" }, "\u0421reate a law firm account and manage your team\u2019s matters from one flexible portal."))),
            react_1.default.createElement("div", { className: 'tab-titles mb-30' }, "Create Law Firm"),
            react_1.default.createElement(core_1.Box, { className: 'v2-main-container' },
                react_1.default.createElement(core_1.Box, { id: 'law-firm-profile' },
                    react_1.default.createElement(layouts_1.InfoContainer, { className: 'profile-info-container' },
                        react_1.default.createElement(avatarUpload_1.default, { addAvatar: this.props.addAvatar, imageUrl: formData.imageUrl, removeAvatar: this.formChange, avatarLoading: avatarLoading }),
                        react_1.default.createElement("div", { className: "input-wrapper" },
                            react_1.default.createElement(core_1.Input, { fullWidth: true, value: formData.firm_name, error: validationFields.firmNameValid === false, onChange: (e) => this.formChange(e, 'firm_name'), onBlur: (e) => this.validateInput(e, 'firm_name'), placeholder: 'Law Firm Name', id: "full-name" }))),
                    react_1.default.createElement(core_1.Box, { className: 'profile-details-container' },
                        react_1.default.createElement(layouts_1.InfoContainer, { className: 'w-100 flex-column' },
                            react_1.default.createElement(layouts_1.InfoBlock, { title: 'About' },
                                react_1.default.createElement(profile_1.About, { user: user, inputChange: (e) => this.formChange(e, 'bio'), edit: true, value: formData.bio, error: false })),
                            react_1.default.createElement("div", { className: "block-separator" }),
                            react_1.default.createElement(layouts_1.InfoBlock, { title: 'Contact Information' },
                                react_1.default.createElement(contactInfo_1.default, { user: user, edit: true, formChange: this.formChange, validationFields: validationFields, apiErrors: apiErrors, addressValid: addressValid, validateInput: this.validateInput, setApiError: this.props.setApiError, validateAddress: this.props.validateAddress, formData: formData }))),
                        react_1.default.createElement(actionBox_1.default, { mainBtn: react_1.default.createElement(core_1.Button, { onClick: this.saveProfile, className: 'v2-btn v2-btn-primary' }, "Create Law Firm"), secondaryBtn: react_1.default.createElement(core_1.Button, { onClick: () => {
                                    const experience = localStorage.getItem('experience');
                                    window.location.href = experience === 'crm' ? '/crm/activities' : '#/home';
                                }, className: 'v2-btn v2-btn-tertiary' }, "Never Mind") }),
                        formValid === false || !addressValid ?
                            react_1.default.createElement(core_1.FormHelperText, { error: true, className: 'helper-text-error' }, errorMessage) : null))),
            successModal &&
                react_1.default.createElement(core_1.Dialog, { id: "success-modal", open: openModal },
                    react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement(core_1.DialogContent, { className: 'success-modal' },
                            react_1.default.createElement(core_1.Box, { display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" },
                                react_1.default.createElement("span", { className: "tada-icon" }),
                                react_1.default.createElement("h2", { className: "title" }, "You are on your way to super productivity!"),
                                react_1.default.createElement("p", { className: 'description' }, "Add users to your law firm to manage your contacts, matters and litigation support needs with one efficient platform.")),
                            react_1.default.createElement(core_1.Box, { display: "flex", flexDirection: "column", className: "pt-20" },
                                react_1.default.createElement("div", { className: "info-box" },
                                    react_1.default.createElement("span", null,
                                        react_1.default.createElement(svgIcons_1.CheckIcon, null)),
                                    react_1.default.createElement("div", { className: 'text-wrapper' },
                                        react_1.default.createElement("p", { className: "text-main" }, "Litigation support"),
                                        react_1.default.createElement("p", { className: 'text-secondary' }, "Easily submit appearances, depositions, freelance tasks and case referrals to thousands of attorneys."))),
                                react_1.default.createElement("div", { className: "info-box" },
                                    react_1.default.createElement("span", null,
                                        react_1.default.createElement(svgIcons_1.CheckIcon, null)),
                                    react_1.default.createElement("div", { className: 'text-wrapper' },
                                        react_1.default.createElement("p", { className: "text-main" }, "Contacts and Matters"),
                                        react_1.default.createElement("p", { className: 'text-secondary' }, "Use our CRM features to manage your contacts and matters effectively."))),
                                react_1.default.createElement(core_1.Button, { className: 'v2-btn v2-btn-primary', onClick: () => {
                                        this.setState({ openModal: false });
                                        window.location.href = '#/users';
                                    }, color: "primary" }, "OK, got it"))))));
    }
}
const mapStateToProps = (state) => {
    const { lawFirmProfile, lawFirm } = state;
    return {
        lawFirm,
        lawFirmProfile,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setProfileForm: () => dispatch(lawFirmProfileSlice_1.setProfileForm()),
        userFormChange: ({ value, field }) => dispatch(lawFirmProfileSlice_1.userFormChange({ value, field })),
        validateInputs: (data) => dispatch(lawFirmProfileSlice_1.validateInputs(data)),
        setApiError: ({ field, status }) => dispatch(lawFirmProfileSlice_1.setApiError({ field, status })),
        validateAddress: () => dispatch(lawFirmProfileSlice_1.validateAddress()),
        resetState: () => dispatch(lawFirmProfileSlice_1.resetState()),
        addAvatar: (data) => dispatch(lawFirmProfileSlice_1.addAvatar(data)),
        changeArea: (data, type, deleted) => dispatch(lawFirmProfileSlice_1.changeArea(data, type, deleted)),
        savePracticeAreas: (data, id) => dispatch(lawFirmProfileSlice_1.savePracticeAreas(data, id)),
        togglePracticeAreasModal: () => dispatch(lawFirmProfileSlice_1.togglePracticeAreasModal()),
        setFormUpdate: () => dispatch(lawFirmProfileSlice_1.setFormUpdate()),
        createProfile: () => dispatch(lawFirmProfileSlice_1.createProfile())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(CreateProfile);
